import React, { useMemo } from "react";
import "./CalendarHeader.scss";
import { CenterSnapStrip } from "../CenterSnapStrip";
import YearSelector from "../MultiDateTimeCalendar/YearSelector";
import { getMetricColor, hexToRgba, METRIC } from "../MultiDateTimeCalendar/calendarUtils";

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Mirrors the $pr-* tokens in styles/_colors.scss; the strip takes its colours
// as props, so they cannot come from the stylesheet.
const STRIP_COLORS = {
  background: "rgba(0, 161, 228, 0.15)",
  text: "#6B6C6D",
  selectedTab: "#FFFFFF",
  selectedText: "#00A1E4",
};

// Short label for the badge shown next to the year — mirrors the mobile
// calendar's unit-type chip (e.g. "Quantity" for a shift-threshold contract).
const METRIC_BADGE_LABELS = {
  [METRIC.HOURS]: "Hours",
  [METRIC.QUANTITY]: "Quantity",
  [METRIC.COUNT]: "Requests",
  [METRIC.TOTAL_AMOUNT]: "Amount",
};

const CalendarHeader = ({ currentDate, onMonthChange, onYearSelect, metricType, isLoading = false, showThresholds ,thresholdUnitType}) => {
  const selectedYear = currentDate.getFullYear();
  const selectedMonth = currentDate.getMonth();

  const monthAccessibilityLabels = useMemo(
    () => MONTH_NAMES.map((label) => `${label} ${selectedYear}`),
    [selectedYear]
  );

  const metricBadgeLabel = metricType ? METRIC_BADGE_LABELS[metricType.value] : null;
  const metricBadgeColor = metricType ? getMetricColor(metricType) : null;

  return (
    <div className="calendar-header">
      <div className="calendar-header__top-row">
        <YearSelector
          selectedYear={{ id: selectedYear, title: String(selectedYear) }}
          isLoading={isLoading}
          onYearSelect={onYearSelect}
          textColor={metricBadgeColor}
        />

        {showThresholds && thresholdUnitType && (
          <span
            className="calendar-header__metric-badge"
            style={{ color: metricBadgeColor, backgroundColor: hexToRgba(metricBadgeColor, 0.12) }}
          >
            {thresholdUnitType.charAt(0).toUpperCase() + thresholdUnitType.slice(1)}
          </span>
        )}
      </div>

      <CenterSnapStrip
        labels={MONTH_NAMES}
        selectedIndex={selectedMonth}
        onSelect={(month) => onMonthChange(selectedYear, month)}
        accessibilityLabels={monthAccessibilityLabels}
        backgroundColor={metricBadgeColor ? hexToRgba(metricBadgeColor, 0.15) : STRIP_COLORS.background}
        textColor={STRIP_COLORS.text}
        selectedTabColor={STRIP_COLORS.selectedTab}
        selectedTextColor={metricBadgeColor || STRIP_COLORS.selectedText}
        maxVisibleTabs={7}
      />

      {/* <CenterSnapStrip
        labels={["Today", "Week", "Month", "Year", "All"]}
        selectedIndex={selectedIndex}
        onSelect={setSelectedIndex}
        backgroundColor="#E5F6FC"
        textColor="#777777"
        selectedTabColor="#FFFFFF"
        selectedTextColor="#00A1E4"
      /> */}
    </div>
  );
};

export default CalendarHeader;
